import React from "react";

// Chakra imports
import {Box, Flex, Image, Text, useColorModeValue} from "@chakra-ui/react";
import logo from "assets/img/rewardgo_logo.png";
// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  return (
    <Flex align='flex-start' direction='column'>
      <Box px='25px' mb='25px'>
        <Image
          src={logo}
          h='35px'
        />
      </Box>
      <HSeparator  mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
